import React, {Component} from "react";
import desktop_exit from "../../../../assets/icons/login-x-icon.svg";

import "./index.scss";
import {connect} from "react-redux";
class MembershipDownload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id
        }
        this.animateOut = this.animateOut.bind(this);
        this.animateIn  = this.animateIn.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if(props.popup_id !== state.popup_id) {
            return {animation_class: 'active'}
        }
        return {};
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleOnClick = () =>{
        if (typeof this.props.action === 'function'){
            this.props.action();
        }
        this.animateOut();
    };

    render() {

        const { text = '' } = this.props;
        const btnText = this.props.btnText !== undefined ? this.props.btnText : text["membership_check_popup_btn"];

        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper membership_download_popup " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <button className = "x_close_icon"
                            onClick = { () => this.animateOut() }
                    >
                        <img src={desktop_exit} alt=''/>
                    </button>
                    <div className = "popup_content">
                        <div className="text">{ text["membership_check_open_instructions"] }</div>
                        <button className="accept-button"
                                onClick = { this.handleOnClick }
                                aria-label="אישור">{btnText}</button>
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text:store.config.Translations,
    }
}

const mapDispatchToProps = dispatch =>{
    return{

    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(MembershipDownload);